export default "__VITE_ASSET__eZT6qTDe__"